import { Injectable } from '@angular/core';

import { bombasStorage } from "./data.service";

@Injectable()
export class BombaService {

    constructor(
    ) { }

    //session
    setSessionStorage(item: any) {
        let object: string = JSON.stringify(item);
        sessionStorage.setItem(bombasStorage + '-new', object);
    }

    getSessionStorage() {
        let item: string = sessionStorage.getItem(bombasStorage + "-new");
        return JSON.parse(item);
    }

    clearSessionStorage() {
        sessionStorage.removeItem(bombasStorage + "-new");
    }

    setSessionStorageFatherModule(item: any) {
        let object: string = JSON.stringify(item);
        sessionStorage.setItem(bombasStorage + '-father', object);
    }
}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/abastecimentos/bombas/shared/bomba.service.ts
 **/